import React from 'react';
import clsx from 'clsx';
import { colorPalette, utils } from '@qualifio/ui-commons';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: 'white',
    flex: `0 0 ${utils.pxToRem(270)}`,
    height: '100%',
    overflowY: 'auto',
    width: utils.pxToRem(270),
    border: `1px solid ${colorPalette.grey.main}`,
    borderRadius: 5,
  },
}));

interface Props {
  className?: string;
  children: React.ReactNode;
}

export function MasterViewSidebar({ children, className, ...props }: Props): React.ReactElement {
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, className)} {...props}>
      {children}
    </div>
  );
}
